import React from 'react';

export default function Modal({ title, onClose, children, maxWidth }) {
  return (
    <div className="cs-modal-backdrop" onClick={onClose}>
      <div
        className="cs-modal"
        style={maxWidth ? { maxWidth } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cs-page-head" style={{ marginBottom: 16 }}>
          <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
          <button className="cs-btn cs-btn-ghost cs-btn-sm" onClick={onClose}>
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
